
import {getUserInfo} from '@/utils/userInfo'
import {getToken} from '@/utils/token'
export default {
  userInfo: getUserInfo(),
  token: getToken(),
  libraryModalVisible : false,
  libraryModalInfo : {},
  newGroupModalVisible:false,
  userdownStrfile:''
}



// WEBPACK FOOTER //
// ./src/store/state.js